export default function IconListNumbers({
  className,
  fill,
  stroke = "currentColor",
}: {
  className?: string
  fill?: string
  stroke?: string
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="List-Numbers Streamline Ultimate">
        <path
          id="Vector"
          d="M1.45312 9C1.45313 11.0016 2.24824 12.9211 3.66355 14.3364C5.07887 15.7518 6.99844 16.5469 9 16.5469C11.0016 16.5469 12.9211 15.7518 14.3364 14.3364C15.7518 12.9211 16.5469 11.0016 16.5469 9C16.5469 6.99844 15.7518 5.07887 14.3364 3.66355C12.9211 2.24824 11.0016 1.45313 9 1.45312C6.99844 1.45313 5.07887 2.24824 3.66355 3.66355C2.24824 5.07887 1.45313 6.99844 1.45312 9Z"
          fill={fill}
        />
        <path
          id="Vector_2"
          d="M5.04688 3.60794H17.2656"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M5.04688 9.35794H17.2656"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M5.04688 15.1079H17.2656"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M0.734375 14.203C0.769365 14.0736 0.839854 13.9566 0.937875 13.8651C1.0359 13.7736 1.15754 13.7114 1.28907 13.6855C1.4206 13.6595 1.55676 13.6709 1.68217 13.7182C1.80759 13.7656 1.91726 13.8471 1.99878 13.9535C2.08031 14.06 2.13045 14.1871 2.14353 14.3205C2.15661 14.4539 2.13212 14.5883 2.07282 14.7086C2.01351 14.8288 1.92177 14.93 1.80794 15.0009C1.69412 15.0717 1.56275 15.1093 1.42869 15.1094C1.56251 15.1097 1.69359 15.1473 1.80716 15.2181C1.92074 15.2889 2.0123 15.39 2.07153 15.51C2.13077 15.63 2.15533 15.7641 2.14244 15.8973C2.12956 16.0305 2.07974 16.1575 1.9986 16.2639C1.91747 16.3703 1.80823 16.452 1.68319 16.4997C1.55816 16.5474 1.42229 16.5592 1.29089 16.5339C1.15949 16.5085 1.03778 16.447 0.939454 16.3562C0.841132 16.2654 0.770106 16.149 0.734375 16.02"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M0.734375 8.64062C0.734375 8.45 0.8101 8.26718 0.944892 8.13239C1.07968 7.9976 1.2625 7.92188 1.45312 7.92188C1.64375 7.92188 1.82657 7.9976 1.96136 8.13239C2.09615 8.26718 2.17188 8.45 2.17188 8.64062C2.17189 8.87334 2.09282 9.09916 1.94763 9.28103L0.734375 10.7969H2.17188"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M0.734375 2.17188H1.09375C1.18906 2.17188 1.28047 2.20974 1.34787 2.27713C1.41526 2.34453 1.45312 2.43594 1.45312 2.53125V5.04688"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M0.734375 5.04544H2.17188"
          stroke={stroke}
          vectorEffect="non-scaling-stroke"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
